import { render, staticRenderFns } from "./EomInfoCard.vue?vue&type=template&id=5ed85baa&scoped=true&"
import script from "./EomInfoCard.vue?vue&type=script&lang=js&"
export * from "./EomInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./EomInfoCard.vue?vue&type=style&index=0&id=5ed85baa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed85baa",
  null
  
)

export default component.exports